import { useWizardContext } from 'src/context/wizard/use-wizard-context';

import WizardVariableOptionItem from './wizard-variable-option-item';

export default function WizardVariableOptions() {
  const {
    numberOfFilesToExport,
    handleUpdateVariableOptions,
    variableInfo,
    currentVariableOptions,
  } = useWizardContext();

  if (variableInfo.items.length === 0) {
    return (
      <div className="flex w-full flex-col items-center justify-center gap-1">
        <span className="text-sm text-gray-500">No variables found</span>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-start justify-center gap-1">
      {variableInfo.items.map((variableName) => {
        const options = currentVariableOptions[variableName];
        if (!options) return null;

        return (
          <WizardVariableOptionItem
            key={variableName}
            variableName={variableName}
            variableOptions={options}
            numberOfFilesToExport={numberOfFilesToExport}
            onUpdate={(data) => handleUpdateVariableOptions(variableName, data)}
          />
        );
      })}
    </div>
  );
}
